import { getTimeAgo } from "../helpers/time-converter.js"
import { updateToPost } from "../helpers/collapse.js"
import { el, text, setStyle, mount } from "redom"
import { buildBadge } from "../../utils/common.js"
import type { RecordsSectionCtx, RecordsWithUser } from "#/types";
import { getAuthUser, maybeMeIsMe } from "../../utils/authUser";

export class RecordItem {
    protected badge: HTMLParagraphElement = el("p", { style: "padding-left: 5px" })
    private likes: Text = text("?")
    private pageView: Text = text("?")
    private clock: Text = text("?")
    private recordItemInfo: HTMLDivElement = el(".recordItemInfo",
        [el("p.recordItemLeft",
            [el("i.recordItemIcon fas fa-heart", { style: "padding-right: 5px" }), this.likes,
            el("i.recordItemIcon fas fa-headphones", { style: "padding: 0px 5px 0px 10px " }), this.pageView,
            el("i.recorditemIcon fas fa-clock", { style: "padding: 0px 5px 0px 10px " }), this.clock
            ]), this.badge])
    private recordTitle: HTMLDivElement = el(".recordItemTitle")
    protected recordItemDiv: HTMLDivElement = el(".col", [this.recordTitle, this.recordItemInfo])
    border: HTMLHeadingElement = el("h3.border-bottom noMargin")
    el: HTMLElement = el("record-item", this.recordItemDiv)
    update(data: RecordsWithUser, index?: number, items?: RecordsWithUser[]) {
        const file = data.file
        this.el.id = file.id
        this.likes.textContent = file.liked.toString()
        this.pageView.textContent = file.pageview.toString()
        this.clock.textContent = getTimeAgo(file.uploadedAt)
        mount(this.badge, buildBadge(file))
        this.recordTitle.innerText = file.title
        this.border.style.display = items && index != items.length - 1 ? "block" : "none"
    }
}

export class RecordItemWithImage extends RecordItem {
    private userImage: HTMLImageElement = el("img.rounded", { style: "margin:0px; width:62px; height:62px;", onerror: (e: Event) => { (e.target as HTMLImageElement).src = "/public/img/icon200x200.png" } })
    private row: HTMLDivElement = el(".row record-item clickable", { style: "padding:0.5rem 0" },  el(".col-auto", this.userImage))
    private userName: HTMLDivElement = el(".recordItemInfo")
    constructor () {
        super()
        this.badge.classList = "recordItemBadge"
        this.recordItemDiv.prepend(this.userName)
        mount(this.row, this.recordItemDiv)
        mount(this, this.row)
        this.recordItemDiv.classList.add("recordItemDiv")
        mount(this, this.border)
        this.border.style.marginLeft = "75px"
    }
    override update(data: RecordsWithUser, index?: number, items?: RecordsWithUser[], context?: RecordsSectionCtx) {
        super.update(data, index, items)
        if (context?.isUpNext) this.row.style.paddingBottom = "20px"
        this.row.onclick = context?.hardRefresh ? () => { window.location.href = "/r/" + data.file.id } : () => { updateToPost(data.file.id, context?.targetUrl) }
        this.userName.innerText = data.uploader.name
        if (context?.markedId && context.markedId == data.file.id) {
            this.userImage.src = "/public/img/img_now_playing.svg"
            this.userImage.id = "nowPlayingImage"
            setStyle(this.userImage, { backgroundSize: "62px 62px", padding: "31px", backgroundImage: "url(" + data.uploader.imgUrl + "), url('/public/img/icon200x200.png')" })
            // Padding is 31 to remove the image in the src.:q
        }
        else {
            this.userImage.src = data.uploader.imgUrl
        }
    }
}

export class RecordItemWithoutImage extends RecordItem {
    private row: HTMLDivElement = el(".row record-item clickable", { style: "padding:10px 20px;" })
    private button: HTMLButtonElement = el("button.modalBtn", { 'data-bs-toggle': "modal", 'data-bs-target': "#deleteConfirm" }, el("i.far fa-trash-alt clickable", { style: "font-size: 30px; color: #cccccc;" }))
    private trashcan: HTMLDivElement = el(".col-auto", { style: "width:40px; padding:0 5px; align-right" }, this.button);
    constructor() {
        super()
        this.recordItemDiv.style = "word-break: break-all;"
        this.badge.classList = "recordItemLeft"
        mount(this, this.row)
        mount(this.row, this.recordItemDiv)
        mount(this, this.border)
    }
    override async update(data: RecordsWithUser, index?: number, items?: RecordsWithUser[]) {
        super.update(data, index, items)
        this.recordItemDiv.onclick = () => updateToPost(data.file.id, data.playlistUrl)
        const file = data.file
        this.button.dataset.fileId = file.id
        this.button.dataset.recordTitle = file.title
        const maybeMe = await getAuthUser()
        if (maybeMeIsMe(maybeMe) && maybeMe.get.id == data.uploader?.id) {
            mount(this.row, this.trashcan)
        }
    }
}

// NOTE: This code is needed, since 'PLAY ALL' EXCLUDES files whose status is "PREPROCESSING" while the table list needs to show those files.
// TODO: get the first item(or its id) from the playlist (not from table list since this list has files whose status is PREPROCESSING).
export function getFirstValidId(recordItems: RecordsWithUser[]) {
    const firstItem = recordItems.find(item => item.file.status == "OK")
    return firstItem ? firstItem.file.id : undefined
}
